import { CallUnselectIcon, ChatUnselectIcon, CalendarUnselectIcon } from '@/assets/images';

export const featureRegistry = [
   {
      name: 'chats',
      enabled: true,
      component: () => import('@/features/chats'),
      navIcon: { icon: ChatUnselectIcon },
      listeners: () => import('@/features/chats/listeners').then(m => m.chatListener),
      // chats is always available if enabled; no specific server gate yet
      serverCheck: null,
   },
   {
      name: 'calls',
      enabled: true,
      component: () => import('@/features/calls'),
      navIcon: { icon: CallUnselectIcon },
      listeners: null, // calls uses callkitCallbacks - registered separately in initialize.js
      // show calls tab only if at least one call type is permitted by server
      serverCheck: features => features.isOneToOneCallEnabled || features.isGroupCallEnabled,
   },
   {
      name: 'users',
      enabled: true,
      component: null, // users is a supporting feature, not a top-level nav tab
      navIcon: null,
      listeners: () => import('@/features/users/listeners').then(m => m.userListener),
      serverCheck: null,
   },
   {
      name: 'calendar',
      enabled: true,
      component: () => import('@/features/calendar'),
      navIcon: { icon: CalendarUnselectIcon },
      serverCheck: null,
   },
   {
      name: 'invite',
      enabled: true,
      listeners: () => import('@/features/invite/listeners/onInviteStatusChanged').then(m => m.inviteListener),
      serverCheck: null,
   },
];

/**
 * Resolves and merges all listeners from enabled registry features into a single object.
 * Listeners are loaded lazily - deleting a feature folder won't break the build
 * as long as its registry entry has enabled: false (same as the component field).
 */
export const getRegisteredListeners = async () => {
   const results = await Promise.all(featureRegistry.filter(f => f.enabled && f.listeners).map(f => f.listeners()));
   return results.reduce((acc, listenerObj) => ({ ...acc, ...listenerObj }), {});
};
